import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';

import { inputLabelStyles } from '../styles';

const filter = createFilterOptions();

// a lot of this functionality was based off these two  MUI <Autocomplete /> examples -> links for reference
// https://mui.com/material-ui/react-autocomplete/#creatable
// https://mui.com/material-ui/react-autocomplete/#checkboxes

export const VpTagInput = ({
  onChange,
  options,
  value,
  label,
  placeholder,
  hideHelperText = false,
  freeSolo = true,
  optionValueKey = 'id',
  optionLabelKey = 'name',
  ...rest
}) => {
  const filterOptions = (options, params) => {
    const filtered = filter(options, params);

    const { inputValue } = params;
    // Suggest the creation of a new value
    const isExisting = options.some((option) => inputValue === option[optionLabelKey]);
    if (inputValue !== '' && !isExisting) {
      filtered.push({
        inputValue,
        name: `Add "${inputValue}"`
      });
    }

    return filtered;
  };

  const getOptionLabel = (option) => {
    // Value selected with enter, right from the input
    if (typeof option === 'string') {
      return option;
    }
    // Add "xxx" option created dynamically
    if (option.inputValue) {
      return option.inputValue;
    }
    // Regular option
    return option[optionLabelKey] || '';
  };

  const renderTags = (value, getTagProps) =>
    value.map((option, index) => (
      <Chip
        key={option[optionValueKey]}
        label={option[optionLabelKey]}
        {...getTagProps({ index })}
      />
    ));

  const renderOption = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox style={{ marginRight: 8 }} checked={selected} />
      {option[optionLabelKey]}
    </li>
  );

  const selectedValues = useMemo(
    () =>
      options?.filter((opt) => value?.find((val) => val[optionValueKey] === opt[optionValueKey])),
    [options, value]
  );

  const renderInput = (params) => (
    <TextField
      {...params}
      label={label}
      placeholder={!value?.length ? placeholder : ''}
      variant="outlined"
      helperText={!hideHelperText ? <span>&nbsp;</span> : undefined}
      InputLabelProps={{
        shrink: false,
        sx: inputLabelStyles
      }}
    />
  );

  const handleOnChange = (value, newValue) => {
    onChange(newValue);
  };

  return (
    <Autocomplete
      autoHighlight
      multiple
      disableCloseOnSelect
      options={options}
      size="small"
      freeSolo={freeSolo}
      value={selectedValues}
      onChange={handleOnChange}
      filterOptions={freeSolo ? filterOptions : undefined}
      getOptionLabel={getOptionLabel}
      renderTags={renderTags}
      renderInput={renderInput}
      renderOption={renderOption}
      {...rest}
    />
  );
};

VpTagInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  optionValueKey: PropTypes.string,
  optionLabelKey: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.arrayOf(PropTypes.object),
  freeSolo: PropTypes.bool,
  hideHelperText: PropTypes.bool
};

export default VpTagInput;



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpTagInput/VpTagInput.jsx